import React from 'react';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function PenLightIcon(props) {
  return <FontAwesomeIcon icon={faPen} {...props} />;
}
